/**
 * Copyright (c) 2022 Animation Studio Voronezh.
 *
 * CONFIDENTIAL AND PROPRIETARY
 *
 * This work is provided "AS IS" and subject to the Prodtrack
 * Source Code License. By accessing, using, copying or modifying
 * this work you indicate your agreement to the Prodtrack Source Code License.
 * All rights not expressly granted therein are reserved by Animation Studio Voronezh.
 */

import React from "react";
import {
    Button,
    Form,
    Grid,
    Header,
    Image,
    Message,
    Segment,
} from "semantic-ui-react";
import QRCode from "react-qr-code";
import AuthenticatingOverlay from "./AuthenticatingOverlay";

const handleClickCopySecret = (deviceSecret) => {
    navigator?.clipboard?.writeText(deviceSecret) ?? null;
};

const SecondStepLogin = ({
    isDarkTheme,
    credentials,
    error,
    handleChange,
    clickLoginButton,
    isAuthenticating,
    deviceURI,
    deviceSecret,
}) => (
    <Grid
        className={isDarkTheme ? "login-dark" : "login-light"}
        textAlign="center"
        style={{ height: "100vh", margin: 0 }}
        verticalAlign="middle"
    >
        <AuthenticatingOverlay active={isAuthenticating} />
        <Grid.Column style={{ maxWidth: 450 }}>
            <Image src="/static/logo.png" centered alt="" />
            <Header as="h2" color="blue" textAlign="center">
                Verification step
            </Header>

            {deviceURI && (
                <Segment>
                    <Message compact>
                        Open the code generation app, scan the QR code in it or
                        enter the secret key manualy{" "}
                        <span
                            onClick={() => handleClickCopySecret(deviceSecret)}
                            style={{ fontWeight: "bold", cursor: "pointer" }}
                        >
                            {deviceSecret}
                        </span>
                    </Message>
                    <QRCode value={deviceURI} />
                </Segment>
            )}
            <Form size="large">
                <Segment stacked>
                    <Form.Input
                        fluid
                        icon="key"
                        iconPosition="left"
                        placeholder="OTP token"
                        name="otp_token"
                        type="password"
                        value={credentials.otp_token}
                        onChange={handleChange}
                        error={error.otp_token}
                    />
                    <Button
                        color="blue"
                        fluid
                        size="large"
                        onClick={clickLoginButton}
                        loading={isAuthenticating}
                        disabled={isAuthenticating}
                    >
                        Verify
                    </Button>
                </Segment>
            </Form>
            {error.wrongToken ? (
                <Message negative>
                    <p>Wrong Token</p>
                </Message>
            ) : null}
        </Grid.Column>
    </Grid>
);

export default SecondStepLogin;
